import React from "react";
import { Button, DatePicker, AutoComplete, message, Card } from "antd";
import Table from "../../Table";
import ChickRateModal from "./ChickRateModal";
import Pagination from "../../Pagination";
import { citesForBroilerOrChick } from "../../../cites";
import { getRates } from "../../../RestServices/postingService";
import { connect } from "react-redux";

const styles = {
  addRateButtonContainer: {
    display: "flex",
    justifyContent: "flex-end",
  },
  addRateButton: {
    marginRight: "20px",
    backgroundColor: "#1f910e",
    color: "white",
  },
  paginationContainer: {
    display: "flex",
    justifyContent: "center",
    padding: "5px",
  },
  filterContainer: {
    display: "flex",
    padding: "0px 20px",
  },
  filterDatePicker: {
    width: "150px",
    marginRight: "5px",
  },
  filterCity: {
    width: "150px",
  },
};
class ChickRates extends React.Component {
  state = {
    isModalOpen: false,
    isLoading: false,
    currentPage: 1,
    totalPages: 0,
    rates: [],
  };
  columns = [
    { Header: "City", accessor: "city" },
    { Header: "Date", accessor: "date" },
    { Header: "Rate", accessor: "rate" },
  ];
  onPageChange = (pageNo) =>
    this.setState({ currentPage: pageNo }, () =>
      this.getRates({
        city: this.state.selectedCity,
        date: this.state.selectedDate,
        pageNo: pageNo,
      })
    );
  filterOptions = (inputValue, option) => {
    return (
      option.props.children.toUpperCase().indexOf(inputValue.toUpperCase()) !==
      -1
    );
  };
  onCityChange = (value) => {
    if (value === "") {
      this.setState({ selectedCity: null }, () =>
        this.getRates({
          city: this.state.selectedCity,
          date: this.state.selectedDate,
        })
      );
    }
  };
  selecteCity = (city) =>
    console.log(city) ||
    this.setState({ selectedCity: city }, () =>
      this.getRates({
        city: this.state.selectedCity,
        date: this.state.selectedDate,
      })
    );
  onDateChange = (moment) =>
    this.setState({ selectedDate: moment ? moment.toISOString() : null }, () =>
      this.getRates({
        city: this.state.selectedCity,
        date: this.state.selectedDate,
      })
    );
  openModal = () => this.setState({ isModalOpen: true });
  closeModal = () => this.setState({ isModalOpen: false });
  getRates = async ({ city, date, pageNo }) => {
    try {
      this.setState({ rates: [] });
      const data = await getRates(
        { type: "CHICK", date, city, pageNo },
        this.props.Auth.user.token
      );
      const rates = data.rates.docs.map((rate) => ({
        city: rate.city,
        date: new Date(rate.createdAt).toLocaleDateString(),
        rate: rate.rateDetails.rate,
      }));
      this.setState({
        rates,
        totalPages: data.rates.totalDocs,
        currentPage: data.rates.page,
      });
    } catch (err) {
      this.setState({ rates: [] });
      if (err.response) {
        return message.error(err.response.data.message);
      }
      return message.error(err.message);
    }
  };
  componentDidMount() {
    this.getRates({});
  }
  render() {
    const { isModalOpen, totalPages, currentPage, rates } = this.state;
    return (
      <div>
        <Card>
          <div className="flex-between">
            <div style={styles.filterContainer}>
              <DatePicker
                onChange={this.onDateChange}
                style={styles.filterDatePicker}
                placeholder="Filter By Date"
              />
              <AutoComplete
                style={styles.filterCity}
                onSelect={this.selecteCity}
                dataSource={citesForBroilerOrChick}
                placeholder="Filter By City"
                onChange={this.onCityChange}
                filterOption={this.filterOptions}
              />
            </div>
            <div style={styles.addRateButtonContainer}>
              <Button
                size="large"
                onClick={this.openModal}
                style={styles.addRateButton}
              >
                Add Chick Rate
              </Button>
            </div>
          </div>
        </Card>
        <div>
          <div style={{ marginTop: "20px", marginBottom: "20px" }}>
            <Card>
              <Table data={rates} columns={this.columns} />
            </Card>
          </div>
        </div>
        <div style={styles.paginationContainer}>
          <Pagination
            current={currentPage}
            total={totalPages}
            onPageChange={this.onPageChange}
          />
        </div>
        <ChickRateModal
          isModalOpen={isModalOpen}
          closeModal={this.closeModal}
        />
      </div>
    );
  }
}
const mapStateToProps = (store) => ({
  Auth: store.Authentication,
});
export default connect(mapStateToProps)(ChickRates);
